import React from 'react';
import { AppScope } from '../constants/app-scope.enum';

export const AppScopeContext = React.createContext<{
  appScope: AppScope;
}>({
  appScope: AppScope.Default,
});
